import { memo, ReactNode, useCallback, useContext, useMemo } from "react";
import classNames from "classnames";
import { NavbarContext } from "../../Navbar/NavbarContext/NavbarContext";
import { MenuItemDescription, MenuItemType } from "../../NavbarMenu/types";
import { DropContainerBody } from "../DropContainerBody";
import { MenuItem } from "../MenuItem";

import styles from "../style.module.scss";

type DownDropContainerProps = {
  activeSubItem?: string | undefined,
  activeMenuItem?: boolean,
  className?: string,
  item?: MenuItemType,
  component?: ReactNode,
  dropdownClassName?: string,
  trigger?: "click" | "hover",
  shouldCloseMenuOnMouseLeave?: boolean,
}

export const DownDropContainer = memo<DownDropContainerProps>((
  {
    item,
    className,
    dropdownClassName,
    activeSubItem,
    shouldCloseMenuOnMouseLeave,
    ...props
  }) => {
  const { setIsFade, setOpen } = useContext(NavbarContext);

  const categories = useMemo(() => item?.items?.reduce<{ [key: string]: MenuItemType[] }>((res, curVal) => {
    if (res[curVal?.category!] === undefined) {
      res[curVal?.category!] = [];
    }
    res[curVal?.category!].push(curVal);
    return res;
  }, {}) || {}, [ item?.items ]);

  const hiddenCategory = useMemo(() => !Object.values(categories)
    .flat()
    .some(el => el.showCategory), [ categories ]);

  const handleOnCloseMenu = useCallback(() => {
    if (props?.trigger === "click" && shouldCloseMenuOnMouseLeave) {
      setIsFade(false);
      setOpen(undefined);
    }
  }, [ props?.trigger, setIsFade, setOpen, shouldCloseMenuOnMouseLeave ]);

  return (
    <MenuItem
      {...props}
      item={item}
      isMenu={true}
      className={className}
    >
      <DropContainerBody className={classNames(styles.categoryDrop, dropdownClassName)} close={handleOnCloseMenu}>
        {Object.entries(categories)
          .map(([ item, values ]) => {
            return (
              <div className={styles.categoryWrap} key={item}>

                <span className={classNames(styles.categoryLabel, {
                  [styles.hiddenCategory]: hiddenCategory,
                })}>
                  {values.find((el: MenuItemDescription) => el.showCategory) && item}
                </span>

                <div className={styles.categoryBody}>
                  {values?.map((item) => (
                    <MenuItem
                      key={item.id}
                      item={item}
                      activeSubItem={activeSubItem === item?.label}
                      className={classNames(styles.arrow, {
                        [styles.sideArrow]: item?.items?.length,
                      })}
                    >
                      {item?.items &&
                        //Side dropdown in more section
                        <DropContainerBody className={styles.sideDrop}>
                          {item?.items?.map((el) => <MenuItem key={el.id} className={styles.sideDropItem} item={el} />)}
                        </DropContainerBody>
                      }
                    </MenuItem>
                  ))}
                </div>
              </div>
            );
          })}
      </DropContainerBody>
    </MenuItem>
  );
});
